import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Badge, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Menu, MenuItem, Popover, Stack, Theme, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { getAdminSettingsList, getAgentEvents, getAgentMonitorWfmList, getAgentStateDetail, getContinuousBargeStatus, getUserBargeDetails, getWidgetConfig, logoutAgent, releaseAgent } from '../../../services/api-service';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import WidgetSearch from '../../Widget-Search/Widget-Search';
import '../AgentCurrentState/AgentCurrentState.css';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { Userpilot } from 'userpilot';
import useTableSort from '../../../hooks/useTableSort';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';
import { STATUS_CLASS_MAP, WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import { checkDataAccessFilters, checkRoles, checkSettings, determineFilterType, filterRowsBySearch, getColumnId, getLengthOfProps, getUpdatedFilterType, mapRowDataWithThreshold, secondsToTime } from '../../../utils/util';
import VideoPlayerIcon from '../../admin/common/VideoPlayer/VideoPlayer';
import BargeInDrawerSip from '../../BargeinDrawerSip/BargeinDrawerSip';
import SelectPopover from '../../SelectPopover/SelectPopover';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import AgentStatusCard from './AgentCircularCard';

interface Column {
    id:
    | 'AgentName'
    | 'agentAction'
    | 'HoldDuration'
    | 'Since'
    | 'AgentState'
    | 'CallStatus'
    | 'adminAction'
    | 'hamburger'
    | 'CampaignNameOfLastCall'
    | 'CallFrom_SkillName'
    | 'CallType'
    | 'CustomerPhoneNumber'
    | 'AgentMode'
    | 'AgentId'
    | 'SkillsFormatted'
    | 'GroupsFormatted'
    | 'HoldStatus'
    | 'AgentPhoneNumber'
    | 'sip_location'
    label: string;
    minWidth?: number;
    draggable?: boolean;
    align?: 'right' | 'left' | 'center';
    positionIndex?: number;
    type?: string;
}
const useStyles: any = makeStyles((theme: Theme) => ({
    popoverContent: {
        minWidth: 350,
        fontSize: '12px',
        lineHeight: 2
    },
    dragdropItemsWrapper: {
        display: 'flex',
        height: '100%',
        width: '100%',
        margin: '0 1rem',
        alignItems: 'center'
    },
    dropdownSearchContainer: {
        height: '30px',
        border: '1px solid #D6D6D7',
        borderRadius: '8px',
        backgroundColor: '#F2F2F2'
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        height: '28px',
        borderLeft: '1px solid #D6D6D7',
        borderRadius: '0px 8px 8px 0px',
        width: '193px',
        padding: '0px 8px'
    },
    searchInput: {
        border: 'none',
        outline: 'none'
    },
    dropdownLabelMenuItem: {
        fontWeight: '400 !important',
        fontSize: '12px !important',
        lineHeight: '14px !important',
        color: '#212121 !important',
        width: '149px'
    },
    dropdownMenu: {
        minWidth: 'fit-content !important',
        border: '1px solid #e6e5e6 !important',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04) !important',
        borderRadius: '12px !important',
        marginTop: '10px !important'
    },
    dropdownMenuItem: {
        fontWeight: '400 !important',
        fontSize: '12px !important',
        lineHeight: '14px !important',
        color: '#212121 !important'
    },
}));

const defaultColumns: Column[] = [
    { id: 'AgentId', label: 'Agent Id', minWidth: 110 },
    { id: 'AgentName', label: 'Agent Name', minWidth: 120 },
    { id: 'agentAction', label: '', minWidth: 30 },
    {
        id: 'CampaignNameOfLastCall',
        label: 'Campaign Name',
        draggable: true,
    },
    {
        id: 'CallFrom_SkillName',
        label: 'Call From Skill',
        draggable: true,
    },
    {
        id: 'CallType',
        label: 'Call Type',
        draggable: true,
        minWidth: 50,
    },
    { id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
    { id: 'sip_location', label: 'SIP Location', minWidth: 120 },
    { id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
    // { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
    { id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
    {
        id: 'AgentMode',
        label: 'Mode',
        draggable: true,
        minWidth: 100,
    },
    { id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
    // { id: 'HoldStatus', label: 'Hold Status', minWidth: 120 },
    { id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
    { id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
    { id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
    {
        id: 'adminAction',
        label: 'Admin Action',
        minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
    },
    { id: 'hamburger', label: '', minWidth: 20 }
];

const columnsWithoutDataAccess: Column[] = [
    { id: 'AgentId', label: 'Agent Id', minWidth: 110 },
    { id: 'AgentName', label: 'Agent Name', minWidth: 120 },
    { id: 'agentAction', label: '', minWidth: 30 },
    {
        id: 'CampaignNameOfLastCall',
        label: 'Campaign Name',
        draggable: true,
    },
    {
        id: 'CallFrom_SkillName',
        label: 'Call From Skill',
        draggable: true,
    },
    {
        id: 'CallType',
        label: 'Call Type',
        draggable: true,
        minWidth: 50,
    },
    { id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
    { id: 'sip_location', label: 'SIP Location', minWidth: 120 },
    { id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
    // { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
    { id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
    {
        id: 'AgentMode',
        label: 'Mode',
        draggable: true,
        minWidth: 100,
    },
    { id: 'HoldStatus', label: 'Hold Status', minWidth: 120, draggable: true },
    { id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
    { id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
    { id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
    { id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
    {
        id: 'adminAction',
        label: 'Admin Action',
        minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
    },
    { id: 'hamburger', label: '', minWidth: 20 }
];

const columnsWithDataAccess: Column[] = [
    { id: 'AgentId', label: 'Agent Id', minWidth: 110 },
    { id: 'AgentName', label: 'Agent Name', minWidth: 120 },
    { id: 'agentAction', label: '', minWidth: 30 },
    {
        id: 'CampaignNameOfLastCall',
        label: 'Campaign Name',
        draggable: true,
    },
    {
        id: 'CallFrom_SkillName',
        label: 'Call From Skill',
        draggable: true,
    },
    { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true },
    {
        id: 'CallType',
        label: 'Call Type',
        draggable: true,
        minWidth: 50,
    },
    { id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 125 },
    { id: 'sip_location', label: 'SIP Location', minWidth: 120 },
    { id: 'SkillsFormatted', label: 'Skills', minWidth: 100, align: 'left', draggable: true },
    // { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, align: 'left' },
    { id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 120 },
    {
        id: 'AgentMode',
        label: 'Mode',
        draggable: true,
        minWidth: 100,
    },
    { id: 'HoldDuration', label: 'Hold Time', minWidth: 120, type: 'TIME' },
    { id: 'HoldStatus', label: 'Hold Status', minWidth: 120, draggable: true },
    { id: 'AgentState', label: 'State', draggable: true, minWidth: 80 },
    { id: 'CallStatus', label: 'Last Call', minWidth: 120, align: 'left' },
    { id: 'Since', label: 'Duration', minWidth: 80, type: 'TIME' },
    {
        id: 'adminAction',
        label: 'Admin Action',
        minWidth: checkRoles("ROLE_SCREEN_RECORDING") ? 190 : 135,
    },
    { id: 'hamburger', label: '', minWidth: 20 }
];

const defaultDownloadColumns: Column[] = [
    { id: 'AgentId', label: 'Agent Id', minWidth: 120 },
    { id: 'AgentName', label: 'Agent Name', minWidth: 80 },
    { id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true },
    { id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true },
    { id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 },
    { id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 },
    { id: 'sip_location', label: 'SIP Location', minWidth: 50 },
    { id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true },
    // { id: 'GroupsFormatted', label: 'Groups', minWidth: 50 },
    { id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 },
    { id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 },
    { id: 'HoldStatus', label: 'Hold Status', minWidth: 50 },
    { id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' },
    { id: 'AgentState', label: 'State', draggable: true, minWidth: 50 },
    { id: 'CallStatus', label: 'Last Call Status', minWidth: 50 },
    { id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' },
];

const downloadColumnsWithDataAccess: Column[] = [
    { id: 'AgentId', label: 'Agent Id', minWidth: 120 },
    { id: 'AgentName', label: 'Agent Name', minWidth: 80 },
    { id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true },
    { id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true },
    { id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true },
    { id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 },
    { id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 },
    { id: 'sip_location', label: 'SIP Location', minWidth: 50 },
    { id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true },
    // { id: 'GroupsFormatted', label: 'Groups', minWidth: 50 },
    { id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 },
    { id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 },
    { id: 'HoldStatus', label: 'Hold Status', minWidth: 50 },
    { id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' },
    { id: 'AgentState', label: 'State', draggable: true, minWidth: 50 },
    { id: 'CallStatus', label: 'Last Call Status', minWidth: 50 },
    { id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' },
];

const thresholdItemsDefault = [
    // {
    // 	label: 'Idle',
    // 	key: 'AgentState',
    // 	value: 'IDLE',
    // 	fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    // },
    {
        label: 'Ready',
        key: 'AgentState',
        value: 'READY',
        fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    },
    {
        label: 'Busy',
        key: 'AgentState',
        value: 'BUSY',
        fields: [
            { label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' },
            { label: `Hold Time(in sec's)`, key: 'HoldDuration', value: '', condition: 'GREATER_THAN' }
        ]
    },
    {
        label: 'ACW',
        key: 'AgentState',
        value: 'ACW',
        fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    },
    {
        label: 'Pause',
        key: 'AgentState',
        value: 'PAUSED',
        fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    },
    // {
    // 	label: 'Calling',
    // 	key: 'AgentState',
    // 	value: 'CALLING' || 'Calling',
    // 	fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    // },
    {
        label: 'AUX',
        key: 'AgentState',
        value: 'AUX',
        fields: [{ label: `Duration(in sec's)`, key: 'Since', value: '', condition: 'GREATER_THAN' }]
    }
];

export default function AgentCurrentStateCircular(props: any) {
    const fullscreenContainer = props?.fullscreenContainer
    const { useState, useRef } = React;
    const classes = useStyles();
    const [responseLength, setresponseLength] = useState<Number>(0);
    const [allowedFilters, setAllowedFilters] = useState<string[]>(['Campaign', 'Skill', 'Group', 'CampaignType']);
    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
    const [rowData, setRowData] = useState<Array<any>>([]);
    const [columns, setColumns] = useState<Array<any>>(defaultColumns);
    const [downloadColumns, setDownloadColumns] = useState<Array<any>>(defaultDownloadColumns);
    const [filteredRowData, setFilteredRowData] = useState<Array<any>>([]);
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const [isColumnsPopoverOpen, setIsColumnsPopoverOpen] = useState<boolean>(false);
    const [isBargeInOpen, setIsBargeInOpen] = useState<boolean>(false);
    const [columnsEleRefPoint, setColumnsElRefPoint] = useState<any>(null);
    const [selectedAgent, setSelectedAgent] = useState<any>(null);
    const [selectedAgentDetails, setSelectedAgentDetails] = useState<any>(null);
    const [selectedAgentEventDetails, setSelectedAgentEventDetails] = useState<any>(null);
    const [selectedColumns, setSelectedColumns] = useState<any>(props?.selectedFilters?.filterHeaders?.data || columns);
    const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || (checkDataAccessFilters() ? 3 : 1));
    const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
    const [agentListFilter, setAgentListFilter] = useState<any>(props?.selectedFilters?.filters || []);
    const downloadContent = useRef<null | any>(null);
    const [groupingColumns, setGroupingColumns] = useState<any>(props?.widgetData?.groupingColumns || []);
    const [groupedData, setGroupedData] = useState<any>({});
    const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
    const [thresholdItems, setThresholdItems] = useState<Array<any>>(thresholdItemsDefault);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [openLogOffAlert, setOpenLogOffAlert] = React.useState(false);
    const [releaseDetails, setReleaseDetails] = React.useState<any>([]);
    const [logOffDetails, setLogOffDetails] = React.useState<any>([]);
    const [searchText, setSearchText] = useState<any>({});
    const searchTextRef = useRef('');
    const [sipClient, setSipClient] = useState<any>("");
    const [sipUrl, setSipUrl] = useState<any>("");
    const [bargeinCallType, setBargeinCallType] = useState<any>("");
    const [onselect, setOnSelect] = useState(false);
    const [settings, setSettings] = useState<any>([]);
    const [continuousBarge, setContinuousBarge] = useState(false);
    const tableContainerRef = useRef(null);
    const tableDataRef = useRef(null);
    const [resized, setResized] = useState<any>(false);
    const [moreData, setMoreData] = useState<any>(false);
    const [selectedDownloadData, setSelectedDownloadData] = useState<any>(downloadColumns);
    const [screenBargeinData, setScreenBargeinData] = useState<any>(null);
    const searchKeyRef = useRef('');
    const [savedThresholdList, setSavedThresholdList] = useState<any>({
        thresholdList: props?.selectedThresholds?.thresholdList?.length ? props?.selectedThresholds?.thresholdList : [],
        showSkillList: props?.selectedThresholds?.showSkillList || false
    });
    const { sortData, handleSort, getSortIcon, getSortedGroupData, sortGroupedData } = useTableSort({
        defaultSortConfig: { key: 'AgentName', direction: 'ascending' }
    });
    const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
    const getAgentIncId = (agent: any) => agent?.AgentIncId ?? agent?.AgentUniqueId;
    const hasOwnMetric = (row: any, key: 'TotalCalls' | 'AnsweredCalls' | 'AbandonedCalls') => {
        try {
            return row && Object.prototype.hasOwnProperty.call(row, key) && row[key] !== null && row[key] !== undefined && row[key] !== '';
        } catch (error) {
            return false;
        }
    }

    const [groupByAnchor, setGroupByAnchor] = useState<null | HTMLElement>(null);
    const [sortByAnchor, setSortByAnchor] = useState<null | HTMLElement>(null);


    const prevAdditionalFilters = React.useMemo(() => {
        if (props?.selectedFilters?.extraParams) {
            try {
                return (JSON.parse(props.selectedFilters.extraParams));
            }
            catch (err) {
                console.error("Error parsing extraParams", err);
                return { state: [], mode: [] }
            }
        }
        return { state: [], mode: [] }
    }, [props?.selectedFilters?.extraParams]);

    const [additionalFilters, setAdditionalFilters] = useState<any>(prevAdditionalFilters);

    const additionalFiltersLength = React.useMemo(() => {
        let count = 0;
        if (additionalFilters?.state?.length) {
            count += additionalFilters.state.length;
        }
        if (additionalFilters?.mode?.length) {
            count += additionalFilters.mode.length;
        }
        return count;
    }, [additionalFilters]);

    const [isAdminActionSettingEnabled, setAdminActionSetting] = useState(false);

    const intervalRef = useRef<any>(null);
    const loadingRef = useRef<boolean>(false);
    const isRealTimeSkillUpdateRef = useRef<boolean>(false);

    React.useEffect(() => {
        const checkAdminActionSetting = async () => {
            try {
                const resp = await checkSettings("DSBL_ADMNACT_IF_BUSY");
                console.log("isAdminActionSettingEnabled ~ resp:", resp)
                setAdminActionSetting(resp)
            }
            catch (err) {
                console.log(err);
            }
        }
        checkAdminActionSetting();
    }, [])

    React.useEffect(() => {
        selectedDownloadColumns();
    }, [selectedColumns])

    React.useEffect(() => {
        if (savedThresholdList && savedThresholdList.thresholdList && savedThresholdList.thresholdList.length) {
            console.log('thresholdItems savedThresholdList useEffect', savedThresholdList);
            setThresholdItems(savedThresholdList.thresholdList);
        }
    }, [savedThresholdList.thresholdList]);

    React.useEffect(() => {
        const filterHeaders = props?.selectedFilters?.filterHeaders?.data;
        const dataAccessEnabled = checkRoles("ROLE_DATA_ACCESS");
        if (dataAccessEnabled) {
            setColumns(columnsWithDataAccess);
            setDownloadColumns(downloadColumnsWithDataAccess);
            setSelectedDownloadData(downloadColumnsWithDataAccess);
        } else {
            setColumns(columnsWithoutDataAccess);
            setDownloadColumns(defaultDownloadColumns);
            setSelectedDownloadData(defaultDownloadColumns);
        }
        if (filterHeaders && Array.isArray(filterHeaders)) {
            const currColumns = (dataAccessEnabled ? columnsWithDataAccess : defaultColumns);
            const filteredColumns = filterHeaders?.filter((column) => currColumns?.filter((col) => col.id == column.id));
            setSelectedColumns(filteredColumns);
        }
    }, []);

    React.useEffect(() => {
        const fetchWidgetConfig = async () => {
            try {
                if (checkDataAccessFilters()) {
                    let widgetConfig = await getWidgetConfig('104', 'widget');
                    if (widgetConfig) {
                        if (typeof widgetConfig === 'string') {
                            widgetConfig = JSON.parse(widgetConfig);
                        }
                        // Check the condition and set the appropriate filters
                        const filters = widgetConfig.data && checkDataAccessFilters()
                            ? widgetConfig.data
                            : widgetConfig.config;

                        if (filters) {
                            const filtersArray = filters.split(',');
                            setAllowedFilters(filtersArray);
                            const determinedFilterType = determineFilterType(filtersArray);
                            if (determinedFilterType !== undefined) {
                                setFilterType(determinedFilterType);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching widget config:', error);
            }
        };
        fetchWidgetConfig();
    }, []);

    React.useEffect(() => {
        Userpilot.initialize('456987');
        Userpilot.identify('456987',
            {
                userid: localStorage.getItem("userId"),
                username: localStorage.getItem("userName")
            }
        );
        Userpilot.track('AgentsList-Active', { name: localStorage.getItem("userName") });
        const resizeObserver = new ResizeObserver((entries) => {
            if (entries && entries.length > 0) {
                const newHeight: any = entries[0].target.clientHeight;
                if (parseInt(newHeight) > 488) {
                    setResized(true)
                }
                if (parseInt(newHeight) === 408) {
                    setResized(false)
                }
                if (parseInt(newHeight) === 618) {
                    setResized(false)
                }
                else if (parseInt(newHeight) >= 748) {
                }
            }
        });

        const resizeDataObserver = new ResizeObserver((entries) => {
            if (entries && entries.length > 0) {
                const Height: any = entries[0].target.clientHeight;
                if (parseInt(Height) > 280) {
                    setMoreData(true)
                }
            }
        });

        if (tableContainerRef.current) {
            resizeObserver.observe(tableContainerRef.current);
        }

        if (tableDataRef.current) {
            resizeDataObserver.observe(tableDataRef.current);
        }

        return () => {
            resizeObserver.disconnect();
            resizeDataObserver.disconnect()
        };
    }, []);


    async function agentListRealTimeSkillUpdate() {
        try {
            const resp = await checkSettings("AG_REAL_TIME_SKL_UPD");
            if (resp && (resp === true || resp === "true")) {
                isRealTimeSkillUpdateRef.current = true;
            } else {
                isRealTimeSkillUpdateRef.current = false;
            }
        } catch (error) {
            console.log("Error in agentListRealTimeSkillUpdate", error);
        }
    }

    React.useEffect(() => {
        try {
            if (checkRoles("ROLE_DATA_ACCESS")) {
                agentListRealTimeSkillUpdate();
            }
        } catch (error) {
            console.log("Error in agentListRealTimeSkillUpdate", error);
        }
    }, []);

    const selectedDownloadColumns: any = () => {
        const selectedHeaders: Column[] = selectedColumns;
        if (props?.selectedFilters?.filterHeaders?.data) {
            const filterData = downloadColumns.filter(item1 =>
                selectedHeaders.some(item2 => item1.id === item2.id)
            );
            setSelectedDownloadData(filterData);
        }
    }

    React.useEffect(() => {
        getSettings();
        continuousBargeEnabled();
    }, [bargeinCallType])

    React.useEffect(() => {
        console.log("ROLE_CONTINUE_BARGE , continuousBarge", checkRoles("ROLE_CONTINUE_BARGE"), continuousBarge)
        if (selectedAgent && checkRoles("ROLE_CONTINUE_BARGE") && continuousBarge) {
            const selectedAgentIncId = getAgentIncId(selectedAgent);
            const updatedData = rowData?.filter((item: any) => getAgentIncId(item) == selectedAgentIncId)
            if (updatedData.length > 0 && updatedData[0]?.AgentState != selectedAgent?.AgentState) {
                if (updatedData[0]?.AgentState === 'BUSY') {
                    updatedData[0].continuousBarge = true;
                }
                setSelectedAgent(updatedData[0]);
            }
        }
    }, [rowData])


    const getPopoverContent = () => {
        console.log("selectedAgent in popover:", selectedAgentDetails);
        return (
            selectedAgentDetails && <Box sx={{ maxHeight: 600 }}>
                {/* Header Section */}
                <Box sx={{
                    p: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #e0e0e0',
                    bgcolor: '#fff'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 500,
                                fontSize: '16px',
                                color: '#000',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '190px'
                            }}
                            title={selectedAgent?.AgentName || 'NA'}
                        >
                            {selectedAgent?.AgentName || 'NA'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', fontSize: '14px', flexShrink: 0 }}>
                            Mode: <strong>{selectedAgent?.AgentMode || 'NA'}</strong>
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', fontSize: '14px', flexShrink: 0 }}>
                            State: <span className={STATUS_CLASS_MAP[selectedAgent?.AgentState || 'CALLING']} style={{ fontWeight: 'bold' }}>
                                {selectedAgent?.AgentState || 'NA'}
                                {(((typeof selectedAgent?.HoldDuration === 'object' ? selectedAgent?.HoldDuration?.value : selectedAgent?.HoldDuration) > 0) && selectedAgent?.AgentState === 'BUSY') &&
                                    <PauseCircleIcon
                                        sx={{
                                            color: 'red !important',
                                            position: 'absolute',
                                            top: '13px',
                                            fontSize: '14px'
                                        }}
                                    />}
                            </span>
                        </Typography>
                    </Box>
                    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={selectedAgent?.AgentState === 'BUSY' && isAdminActionSettingEnabled}
                            disableRipple
                            onClick={() => agentClick('RELEASE', selectedAgent)}
                            sx={{
                                textTransform: 'uppercase',
                                fontSize: '11px',
                                color: '#2196f3',
                                borderColor: '#2196f3',
                                minWidth: 'auto',
                                px: 1.5,
                                cursor: selectedAgent?.AgentState === 'BUSY' && isAdminActionSettingEnabled ? 'not-allowed' : 'pointer',
                                '&:hover': {
                                    backgroundColor: 'rgba(33, 150, 243, 0.04)'
                                },
                                '&.Mui-disabled': {
                                    color: 'rgba(33, 150, 243, 0.4)',
                                    borderColor: 'rgba(33, 150, 243, 0.4)'
                                }
                            }}
                        >
                            RELEASE
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={selectedAgent?.AgentState === 'BUSY' && isAdminActionSettingEnabled}
                            disableRipple
                            onClick={() => agentClick('LOGOUT', selectedAgent)}
                            sx={{
                                textTransform: 'uppercase',
                                fontSize: '11px',
                                color: '#f44336',
                                borderColor: '#f44336',
                                minWidth: 'auto',
                                px: 1.5,
                                cursor: selectedAgent?.AgentState === 'BUSY' && isAdminActionSettingEnabled ? 'not-allowed' : 'pointer',
                                '&:hover': {
                                    backgroundColor: 'rgba(244, 67, 54, 0.04)'
                                },
                                '&.Mui-disabled': {
                                    color: 'rgba(244, 67, 54, 0.4)',
                                    borderColor: 'rgba(244, 67, 54, 0.4)'
                                }
                            }}
                        >
                            LOGOUT
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={selectedAgent?.AgentState !== 'BUSY' || (selectedAgent?.AgentMode === 'DIGITAL' && selectedAgent?.AgentState === 'BUSY')}
                            disableRipple
                            onClick={() => agentClick('BARGEIN', selectedAgent)}
                            sx={{
                                textTransform: 'uppercase',
                                fontSize: '11px',
                                color: '#ff9800',
                                borderColor: '#ff9800',
                                minWidth: 'auto',
                                px: 1.5,
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 152, 0, 0.04)'
                                },
                                '&.Mui-disabled': {
                                    color: 'rgba(255, 152, 0, 0.4)',
                                    borderColor: 'rgba(255, 152, 0, 0.4)'
                                }
                            }}
                        >
                            BARGEIN
                        </Button>
                        {/* {checkRoles("ROLE_SCREEN_RECORDING") && (
                            <Button
                                variant="outlined"
                                size="small"
                                disableRipple
                                onClick={() => agentClick('SCREEN_BARGEIN', selectedAgent)}
                                sx={{
                                    textTransform: 'uppercase',
                                    fontSize: '11px',
                                    color: '#9c27b0',
                                    borderColor: '#9c27b0',
                                    minWidth: 'auto',
                                    px: 1.5,
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        backgroundColor: 'rgba(156, 39, 176, 0.04)'
                                    }
                                }}
                            >
                                SCREEN BARGEIN
                            </Button>
                        )} */}
                        <IconButton size="small" onClick={handleOnPopoverClose} sx={{ ml: 1 }}>
                            <CloseOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>

                {/* Main Content - Two Columns */}
                <Box sx={{ display: 'flex' }}>
                    {/* Left Column - Agent Information */}
                    <Box sx={{ width: '350px', borderRight: '1px solid #e0e0e0' }}>
                        {/* Agent Information Section - Blue Background */}
                        <Box sx={{ bgcolor: '#1565c0', color: 'white', p: 1.5 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '14px', color: 'white' }}>
                                Agent Information
                            </Typography>
                        </Box>
                        <Box sx={{ bgcolor: '#1565c0', color: 'white', px: 2, pb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: 'white' }}>Total Calls</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>
                                    {selectedAgentDetails?.TotalCalls || 'NA'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: 'white' }}>Calls Failed</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>
                                    {selectedAgentDetails?.AbandonedCalls || 'NA'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, gap: 1 }}>
                                <Typography sx={{ fontSize: '13px', flexShrink: 0, color: 'white' }}>Agent Id</Typography>
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: 'white',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '180px'
                                    }}
                                    title={selectedAgent?.AgentId || 'NA'}
                                >
                                    {selectedAgent?.AgentId || 'NA'}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Performance Section - Light Gray Background */}
                        <Box sx={{ bgcolor: '#f5f5f5', px: 2, pt: 2 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '14px', color: '#666', mb: 1 }}>
                                Performance
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Calls Taken</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {selectedAgentDetails?.AnsweredCalls || 'NA'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Avg Handling Time</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.AverageHandlingDuration) || 'NA'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Avg Pickup Time</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.AverageSpeedToAnswer) || 'NA'}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Avg Hold Time</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.AverageHoldDuration) || 'NA'}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, pb: 2 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Wrap Time</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.TotalWrapupDuration) || 'NA'}
                                </Typography>
                            </Box>

                        </Box>

                        {/* Summary Section - Continues Gray Background */}
                        <Box sx={{ bgcolor: '#f5f5f5', px: 2, pb: 2 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '14px', color: '#666', mb: 1 }}>
                                Summary
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Logged In</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.TotalLoginDuration) || 'NA'}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>Last Logout Time</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {selectedAgentDetails?.LastLogoutTime || 'NA'}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                                <Typography sx={{ fontSize: '13px', color: '#333' }}>On Break</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                                    {secondsToTime(selectedAgentDetails?.TotalPauseDuration) || 'NA'}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Right Column - Agent Timeline */}
                    <Box sx={{ flex: 1, minHeight: '500px' }}>
                        <Box sx={{ bgcolor: '#f9f9f9', p: 1.5, borderBottom: '1px solid #e0e0e0' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '14px' }}>
                                Agent Timeline
                            </Typography>
                        </Box>
                        <Box sx={{ p: 3, maxHeight: 460, overflowY: 'auto', bgcolor: '#fff' }}>
                            {selectedAgentEventDetails && selectedAgentEventDetails.length > 0 ? (
                                <Stack direction={'column'} spacing={2}>
                                    {selectedAgentEventDetails.map((item: any, idx: number) => (
                                        <Box key={idx} display={'flex'} gap={2} alignItems={'flex-start'}>
                                            <Box
                                                sx={{
                                                    background: getColorByAgentEvent(item.Event),
                                                    width: '4px',
                                                    minHeight: '40px',
                                                    borderRadius: '2px',
                                                    flexShrink: 0
                                                }}
                                            />
                                            <Box sx={{ flex: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: '500',
                                                        fontSize: '13px',
                                                        color: '#212121',
                                                        mb: 0.3
                                                    }}
                                                >
                                                    {item.Event} {formatAMPM(new Date(item?.StartTime))}
                                                </Typography>
                                                {item?.StartTime && item?.EndTime && (
                                                    <Typography sx={{ fontSize: '11px', color: '#999' }}>
                                                        Duration: {getTimeDifferenceInString(item?.EndTime, item?.StartTime)}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    ))}
                                </Stack>
                            ) : (
                                <Stack direction={'column'} spacing={2}>
                                    <Box display={'flex'} gap={2} alignItems={'flex-start'}>
                                        <Box
                                            sx={{
                                                background: '#dc3545',
                                                width: '4px',
                                                minHeight: '40px',
                                                borderRadius: '2px'
                                            }}
                                        />
                                        <Box>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#212121' }}>
                                                Agent event data not available at this moment.
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Stack>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    };


    const formatAMPM = (date: Date) => {
        if (date) {
            var hours = date.getHours();
            var minutes: any = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        } else {
            return '';
        }
    };

    const getColorByAgentEvent = (event: string) => {
        return event.toLowerCase() === 'calling'
            ? 'yellow'
            : event.toLowerCase() === 'aux'
                ? 'green'
                : event.toLowerCase() === 'release'
                    ? 'red'
                    : event.toLowerCase() === 'idle'
                        ? 'orange'
                        : event.toLowerCase() === 'incall'
                            ? 'lightgreen'
                            : '';
    };

    const getTimeDifferenceInString = (higherDate: string, lowerDate: string) => {
        const seconds = (new Date(higherDate).getTime() - new Date(lowerDate).getTime()) / 1000;
        if (!isNaN(seconds)) {
            if (seconds > 60) {
                const minutes = seconds / 60;
                if (minutes > 60) {
                    const hours = minutes / 60;
                    return `${hours.toFixed(1)} Hrs`;
                } else {
                    return `${Math.floor(minutes)} Mins`;
                }
            } else {
                return `${seconds} Secs`;
            }
        } else {
            return '';
        }
    };

    const handleOnPopoverClose = () => {
        setSelectedAgent(null);
        setSelectedAgentDetails(null);
        setSelectedAgentEventDetails(null);
        setIsPopoverOpen(false);
    };


    const handleOnColumnsPopoverClose = () => {
        setColumnsElRefPoint(null);
        setIsColumnsPopoverOpen(false);
    };

    const handleOnSelectColumnChange = (selected: any) => {

        let selectedIds: string[] = []
        let orderedSelected = [];

        selected.map((selected: any) => {
            selectedIds.push(selected.id)
        })

        if (selectedIds.includes("AgentId")) {
            orderedSelected.push({ id: 'AgentId', label: 'Agent Id', minWidth: 120 })
        }
        if (selectedIds.includes("AgentName")) {
            orderedSelected.push({ id: 'AgentName', label: 'Agent Name', minWidth: 80 })
        }
        if (selectedIds.includes("agentAction")) {
            orderedSelected.push({ id: 'agentAction', label: '', minWidth: 30 })
        }
        if (selectedIds.includes("CampaignNameOfLastCall")) {
            orderedSelected.push({ id: 'CampaignNameOfLastCall', label: 'Campaign Name', draggable: true })
        }
        if (selectedIds.includes("CallFrom_SkillName")) {
            orderedSelected.push({ id: 'CallFrom_SkillName', label: 'Call From Skill', draggable: true })
        }
        if (selectedIds.includes("CallType")) {
            orderedSelected.push({ id: 'CallType', label: 'Call Type', draggable: true, minWidth: 50 })
        }
        if (selectedIds.includes("AgentPhoneNumber")) {
            orderedSelected.push({ id: 'AgentPhoneNumber', label: 'Agent Phone No.', minWidth: 50 })
        }
        if (selectedIds.includes("sip_location")) {
            orderedSelected.push({ id: 'sip_location', label: 'SIP Location', minWidth: 50 })
        }
        if (selectedIds.includes("SkillsFormatted")) {
            orderedSelected.push({ id: 'SkillsFormatted', label: 'Skills', minWidth: 50, draggable: true })
        }
        if (selectedIds.includes("GroupsFormatted")) {
            orderedSelected.push({ id: 'GroupsFormatted', label: 'Groups', minWidth: 50, draggable: true })
        }
        if (selectedIds.includes("CustomerPhoneNumber")) {
            orderedSelected.push({ id: 'CustomerPhoneNumber', label: 'Customer No.', minWidth: 50 })
        }
        if (selectedIds.includes("AgentMode")) {
            orderedSelected.push({ id: 'AgentMode', label: 'Mode', draggable: true, minWidth: 30 })
        }
        if (selectedIds.includes("HoldStatus")) {
            orderedSelected.push({ id: 'HoldStatus', label: 'Hold Status', minWidth: 50, draggable: true })
        }
        if (selectedIds.includes("HoldDuration")) {
            orderedSelected.push({ id: 'HoldDuration', label: 'Hold Time', minWidth: 65, type: 'TIME' })
        }
        if (selectedIds.includes("AgentState")) {
            orderedSelected.push({ id: 'AgentState', label: 'State', draggable: true, minWidth: 50 })
        }
        if (selectedIds.includes("CallStatus")) {
            orderedSelected.push({ id: 'CallStatus', label: 'Last Call Status', minWidth: 50 })
        }
        if (selectedIds.includes("Since")) {
            orderedSelected.push({ id: 'Since', label: 'Duration', minWidth: 50, type: 'TIME' })
        }
        if (selectedIds.includes("adminAction")) {
            orderedSelected.push({ id: 'adminAction', label: 'Admin Action', minWidth: 185 })
        }
        if (selectedIds.includes("hamburger")) {
            orderedSelected.push({ id: 'hamburger', label: '', minWidth: 20 })
        }
        props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: orderedSelected });
        setSelectedColumns(orderedSelected);
        handleOnColumnsPopoverClose();
    };

    const toggleDrawer = (isOpen: boolean) => {
        setIsDrawerOpen(isOpen);
    };

    const getTableData = async (filters = '0') => {
        try {
            if (loadingRef.current) return;
            loadingRef.current = true;
            let state = additionalFilters?.state?.length > 0 ? additionalFilters.state.join(',') : 'All';
            let mode = additionalFilters?.mode?.length > 0 ? additionalFilters.mode.join(',') : 'All';
            let data = await getAgentMonitorWfmList({ filters, type: getUpdatedFilterType(filterType, 'number'), state, mode });
            if (data && data?.length > 0) {
                data = data.filter((item: any) => item?.AgentState && item?.AgentUniqueID !== '0');
            }
            if (data == null || data?.length === 0) {
                setRowData([]);
                setFilteredRowData([]);
                return;
            }
            const updatedRowData = mapRowDataWithThreshold(thresholdItems, data);
            for (const row of updatedRowData) {
                const skills = row.AgentSkills?.split(',') || [];
                const groups = row.AgentGroups?.split(',') || [];
                const tempSkills = [...skills];
                const tempGroups = [...groups];
                if (groups.length > 1) {
                    row.GroupsFormatted = (
                        <div>
                            {groups.slice(0, 1).join(',')}
                            <span key="badge" className="badge" title={tempGroups.join(',')}>
                                {`+${groups.length - 1}`}
                            </span>
                        </div>
                    );
                }
                else {
                    row.GroupsFormatted = groups.join(',');
                }
                if (skills.length > 1) {
                    row.SkillsFormatted = (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'inline-block', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {skills.slice(0, 1).join(',')}
                            </div>
                            <span key="badge" className="badge" title={tempSkills.join(',')}>
                                {`+${skills.length - 1}`}
                            </span>
                        </div>
                    );
                } else {
                    row.SkillsFormatted = skills.join(',');
                }
                if (row && row.PauseReason) {
                    row.AgentState = row.PauseReason
                }
                if (checkRoles('ROLE_CHAT_CALL') && row && row?.SessionCount && parseInt(row.SessionCount) > 0) {
                    row.AgentState = "BUSY";
                }
                row.HoldStatus = 'Non-Hold'
                if (row && typeof row === "object" && row?.HoldDuration && "HoldDuration" in row && row.HoldDuration && (typeof row.HoldDuration === "number" || !isNaN(Number(row.HoldDuration)))) {
                    row.HoldStatus = row.HoldDuration > 0 ? 'Hold' : 'Non-Hold'
                }
            }
            setRowData(updatedRowData);
            let filteredRows: any = [];
            const currentSearchText = searchTextRef?.current || '';
            if (currentSearchText?.length) {
                filteredRows = filterRowsBySearch({ rows: updatedRowData, searchKey: searchKeyRef.current, searchText: currentSearchText });
                // const filteredRows = updatedRowData.filter((item: any) => item.AgentName.toLowerCase().includes(searchText));
                setFilteredRowData(filteredRows);
            } else {
                setFilteredRowData(updatedRowData);
            }
            setLastFetchedTime(getLastFetchedDetailFromBrowser());
        } catch (error) {
            console.error("Failed to fetch Agent Monitor WFM ", error);
        } finally {
            loadingRef.current = false;
        }
    };

    const handleOnSearch = (event: any) => {
        const searchText = event.target.value.length ? event.target.value.toLowerCase() : '';
        setSearchText(searchText);
        if (searchTextRef) {
            searchTextRef.current = searchText;
        }
        // setSearchTextForAgentID(event.target.value.length ? event.target.value : '')
        if (searchText?.length) {
            let filteredRows: any = [];
            filteredRows = filterRowsBySearch({ rows: rowData, searchKey: searchKeyRef.current, searchText });
            setFilteredRowData(filteredRows);
        } else {
            setFilteredRowData(rowData);
        }
    };

    React.useEffect(() => {
        handleOnSearch({ target: { value: searchText } });
    }, []);

    const getSettings = () => {
        try {
            getAdminSettingsList()
                .then((resp: any) => {
                    setSettings(resp.Data);
                    resp?.Data?.map((item: any) => {
                        if (item?.ParameterCode === "BARGEIN_CALL_TYPE") {
                            if (item?.ParameterValue === null) {
                                setBargeinCallType(item?.DefaultValue);
                            } else if (item?.ParameterValue !== null) {
                                setBargeinCallType(item?.ParameterValue);
                            }
                        }
                        if (item?.ParameterCode === "SIP_CLIENT") {
                            if (item?.ParameterValue === null) {
                                setSipClient(item?.DefaultValue);
                            } else if (item?.ParameterValue !== null) {
                                setSipClient(item?.ParameterValue);
                            }
                        }
                        if (item?.ParameterCode === "BARGE_FROM_USER") {
                            let value: boolean = false;
                            const uniqueKey = `BARGE_FROM_USER`;
                            console.log(`[${uniqueKey}] Checking BARGE_FROM_USER parameter`, item);
                            if (item?.ParameterValue === null) {
                                value = item?.DefaultValue?.toLowerCase() === "true";
                                console.log(`[${uniqueKey}] ParameterValue is null, using DefaultValue:`, item?.DefaultValue, `Evaluated value:`, value);
                            } else {
                                value = item?.ParameterValue?.toLowerCase() === "true";
                                console.log(`[${uniqueKey}] ParameterValue is available:`, item?.ParameterValue, `Evaluated value:`, value);
                            }

                            if (value) {
                                console.log(`[${uniqueKey}] Fetching user barge details:`, value);
                                getUserBargeDetails().then((bargeResp: any) => {
                                    console.log(`[${uniqueKey}] Received barge response:`, bargeResp);
                                    let sipUrl = bargeResp?.Data?.[0]?.sipLocation;
                                    console.log(`[${uniqueKey}] Extracted SIP URL:`, sipUrl);
                                    setSipUrl(sipUrl);
                                });
                            } else {
                                console.log(`[${uniqueKey}] Barge-in is disabled, checking SIP_URL parameter`);
                                const sipItem = resp?.Data?.find(
                                    (i: any) => i?.ParameterCode === "SIP_URL"
                                );
                                if (sipItem) {
                                    const resolvedSipUrl = sipItem?.ParameterValue ?? sipItem?.DefaultValue;
                                    console.log(`[${uniqueKey}] Found SIP_URL parameter:`, sipItem, `Resolved SIP URL:`, resolvedSipUrl);
                                    setSipUrl(resolvedSipUrl);
                                }
                            }
                        }
                    });
                })
                .catch((e) => {
                    console.log("error", e);
                });
        } catch (e) {
            console.log("error2 2 2 22", e);
        }
    };

    const continuousBargeEnabled = () => {
        getContinuousBargeStatus().then((resp: any) => {
            if (resp?.isContinueBargeEnabled) {
                setContinuousBarge(resp?.isContinueBargeEnabled);
            }
        })
    };

    const agentClick = async (action: string, agent: any) => {
        if (action === 'LOGOUT') {
            setOpenLogOffAlert(true);
            setLogOffDetails(agent);
        } else if (action === 'RELEASE') {
            setOpenAlert(true);
            setReleaseDetails(agent);
        } else if (action === 'BARGEIN') {
            setSelectedAgent(agent);
            setOnSelect(true);
            setIsPopoverOpen(false);
            toggleBargeInDrawer();
        } else if (action === "SCREEN_BARGEIN") {
            setScreenBargeinData(agent);
        }
    };


    // Updated agentDetails function to fetch both details and events
    const agentDetails = async (event: any, agent: any) => {
        try {
            setSelectedAgent(agent);
            setSelectedAgentDetails(agent);
            const agentIncId = getAgentIncId(agent);

            // Fetch both agent details and events simultaneously
            const [detailsResponse, eventsResponse] = await Promise.all([
                getAgentStateDetail({ agentId: agentIncId }),
                getAgentEvents({ agentId: agentIncId })
            ]);

            // Set agent details
            const detailsRow = detailsResponse.find((eachAgent: any) => eachAgent);
            setSelectedAgentDetails((prev: any) => ({
                ...(prev || {}),
                ...(detailsRow || {}),
                TotalCalls: hasOwnMetric(prev, 'TotalCalls') ? prev.TotalCalls : detailsRow?.TotalCalls,
                AbandonedCalls: hasOwnMetric(prev, 'AbandonedCalls') ? prev.AbandonedCalls : detailsRow?.AbandonedCalls,
                AnsweredCalls: hasOwnMetric(prev, 'AnsweredCalls') ? prev.AnsweredCalls : detailsRow?.AnsweredCalls
            }));

            // Format and set agent events
            const formattedEvents = eventsResponse.map((dataItem: any) => ({
                ...dataItem,
                StartTime: dataItem.StartTime
                    ? `${dataItem.StartTime.toString().split(' ')[0]}T${dataItem.StartTime.toString().split(' ')[1]}`
                    : '',
                EndTime: dataItem.EndTime
                    ? `${dataItem.EndTime.split(' ')[0]}T${dataItem.EndTime.toString().split(' ')[1]}`
                    : ''
            }));
            setSelectedAgentEventDetails(formattedEvents);

            // Open popover (center-aligned, no need for eleRefPoint)
            setIsPopoverOpen(true);
        } catch (error) {
            console.error("Error fetching agent data:", error);
        }
    };


    const toggleBargeInDrawer = () => {
        setIsBargeInOpen(!isBargeInOpen);
    };

    const toggleBargeInDrawerSip = (value: any) => {
        setIsBargeInOpen(!isBargeInOpen);
        setBargeinCallType('');
        setOnSelect(false)
    };

    const handleFilterDelete = (id: Number) => {
        const newFilter = agentListFilter.filter((item: any) => item.id !== id);
        setAgentListFilter(newFilter);
        props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
    };

    const clearFilter = () => {
        setAgentListFilter([]);
        setAdditionalFilters({ state: [], mode: [] });
        props?.handleFilterChange?.([], filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify({ state: [], mode: [] }), '', '', false, { data: selectedColumns });
    };

    const handleFilterExistingData = (filteredData: any) => {
        setAgentListFilter(filteredData);
        props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
    };

    const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection, additionalFilters }: any) => {
        console.log("responseLength", responseLength)
        console.log("selectedFilters", selectedFilters)
        setAgentListFilter(selectedFilters);
        setFilterType(newFilterType);
        setFilterSection(newfilterSection);
        setAdditionalFilters(additionalFilters);
        props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(additionalFilters), '', '', false, { data: selectedColumns });
        toggleDrawer(false);
    };


    const handleGrouping = (agentData: any) => {
        // Replace existing grouping instead of adding
        let grpCol = [agentData];
        setGroupingColumns(grpCol);
        saveDataToDashboard('groupingColumns', grpCol);
        return;
    }

    const toggleThresholdDrawer = (isOpen: boolean, data: any = null, showSkillList: any = false) => {
        setIsThresholdDrawerOpen(isOpen);
        if (data) {
            const savedThresholdList = structuredClone(data);
            setSavedThresholdList((prev: any) => ({
                showSkillList: showSkillList,
                thresholdList: savedThresholdList
            }));
            if (props?.handleThresholdChange) {
                props.handleThresholdChange?.(savedThresholdList, showSkillList, props?.widgetId);
            }
            setThresholdItems(data);
        }
    };

    React.useEffect(() => {
        const filterIds = (agentListFilter.length && !(responseLength === agentListFilter.length)) ? agentListFilter.map((item: any) => item.id).join(',') : '0';
        console.log("filterIds", filterIds, responseLength, agentListFilter.length, (agentListFilter.length || !(responseLength === agentListFilter.length)))
        getTableData(filterIds);
        intervalRef.current = setInterval(() => getTableData(filterIds), WIDGET_REFRESH_INTERVAL.AGENT_LIST);
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [agentListFilter, thresholdItems, additionalFilters]);

    const filterItems = agentListFilter.map((item: any, index: number) => (
        <Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
    ));

    const handleClose = () => {
        setOpenAlert(false);
    };

    const handleLogOffClose = () => {
        setOpenLogOffAlert(false);
    };

    function getHoldStatus(holdDuration: number) {
        if (holdDuration && typeof holdDuration === 'number' && holdDuration > 0) {
            return 'Hold'
        } else {
            return 'Non-Hold'
        }
    }

    function getRowData(row: any) {
        row = row?.map((item: any) => {
            let rowObj = {
                ...item,
                SkillsFormatted: item?.AgentSkills ? item?.AgentSkills : item?.AgentSkills,
                GroupsFormatted: item?.AgentGroups ? item?.AgentGroups : item?.AgentGroups,
                Since: secondsToTime(item?.Since),
                HoldDuration: secondsToTime(item?.HoldDuration),
                HoldStatus: getHoldStatus(item?.HoldDuration || 0)
            };
            return rowObj;
        });
        return row;
    }

    const handleLogOff = async (row: any) => {
        console.log("row here", row);
        await logoutAgent({ agentUniqueID: getAgentIncId(row), agentId: row.AgentId });
        setOpenLogOffAlert(false);
        handleOnPopoverClose();
    };

    const handleRelease = async () => {
        await releaseAgent({ agentUniqueID: getAgentIncId(releaseDetails), agentId: releaseDetails.AgentId });
        setOpenAlert(false);
        handleOnPopoverClose();
    };

    React.useEffect(() => {
        let groupedData = {};
        if (groupingColumns.length > 0) {
            for (const data of filteredRowData) {
                groupingColumns
                    .reduce((groupAcc: any, column: any, groupIdx: number) => {
                        const key = data[column.id] || '';
                        groupAcc[key] = groupAcc[key] || (groupIdx === groupingColumns.length - 1 ? [] : {});
                        return groupAcc[key];
                    }, groupedData)
                    .push(data);
            }
        }
        setGroupedData(groupedData);
    }, [groupingColumns, filteredRowData]);

    let finalTableData: any = []

    const getAgentListTableData = () => {
        if (groupingColumns.length) {
            finalTableData = []
            const sortedGroupedData = sortGroupedData(groupedData, groupingColumns);
            getFinalRows(sortedGroupedData, 0);
            return finalTableData;
        } else {
            return sortData(filteredRowData);
        }
    }

    const getFinalRows: any = (data: any, index: number) => {
        if (!Array.isArray(data)) {
            return Object.entries(data).map(([groupName, groupRowData]) => {
                const extraCell: any = {}
                for (let i = 0; i < index; i++) {
                    extraCell['extraCell' + i] = ""
                }
                let groupRowDataLength = Array.isArray(groupRowData) ? groupRowData?.length : getLengthOfProps(groupRowData);
                extraCell['index'] = index
                extraCell['groupName'] = groupName;
                extraCell['groupRowDataCount'] = groupRowDataLength;
                finalTableData.push(extraCell);
                getFinalRows(groupRowData, index + 1)
            })
        } else {
            finalTableData = getSortedGroupData(data, finalTableData);
        }
    }

    const additionalFiltersList = () => {
        try {
            return Object.keys(additionalFilters).map((key: any) => {
                if (additionalFilters[key]?.length === 0) return null;
                return additionalFilters[key].map((item: any, index: number) => (
                    <Chip
                        key={index}
                        label={`${key.toUpperCase()} - ${item}`}
                        color="primary"
                        variant="outlined"
                        onDelete={() => {
                            setAdditionalFilters((prev: any) => {
                                let newFilters = { ...prev };
                                newFilters[key] = newFilters[key]?.filter((_: any) => _ !== item);
                                props?.handleFilterChange?.(agentListFilter, filterSection, props?.widgetId, '0', '', '', [], '', JSON.stringify(newFilters), '', '', false, { data: selectedColumns });
                                return newFilters;
                            });
                        }}
                        deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
                ))
            })
        } catch (e) {
            console.log("error", e)
        }
    }

    function saveDataToDashboard(key: string, data: any) {
        if (props && props?.handleSaveDataToFilter) {
            props?.handleSaveDataToFilter({
                widgetId: props?.widgetId,
                value: {
                    [key]: data
                }
            })
        }
    }

    const handleGroupByOpen = (event: React.MouseEvent<HTMLElement>) => {
        setGroupByAnchor(event.currentTarget);
    };

    const handleGroupByClose = () => {
        setGroupByAnchor(null);
    };

    const handleSortByOpen = (event: React.MouseEvent<HTMLElement>) => {
        setSortByAnchor(event.currentTarget);
    };

    const handleSortByClose = () => {
        setSortByAnchor(null);
    };

    const renderGroupedCards = () => {
        const tableData = getAgentListTableData();
        if (!tableData || tableData.length === 0) {
            return (
                <Box
                    ref={downloadContent}
                    sx={{
                        textAlign: 'center',
                        py: 3,
                        color: '#999',
                        fontSize: '14px',
                        fontStyle: 'italic'
                    }}
                >
                    No agents available
                </Box>
            );
        }

        if (!groupingColumns.length) {
            return (
                <Box
                    ref={downloadContent}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(2, 1fr)',
                            sm: 'repeat(3, 1fr)',
                            md: 'repeat(4, 1fr)',
                            lg: 'repeat(6, 1fr)',
                            xl: 'repeat(8, 1fr)'
                        },
                        gap: 2
                    }}
                >
                    {tableData?.map((agent: any, index: number) => (
                        <AgentStatusCard
                            action={agentDetails}
                            key={index}
                            agent={agent}
                        />
                    ))}
                </Box>
            );
        }

        // Simple single-level grouping
        const groups: { [key: string]: any[] } = {};
        const groupOrder: string[] = [];

        tableData?.forEach((item: any) => {
            // Skip if it's a group header (from table grouping logic)
            if (item.groupName !== undefined) {
                return;
            }

            // Get the grouping key from the first grouping column
            const groupKey = item[groupingColumns[0].id] || 'Ungrouped';

            if (!groups[groupKey]) {
                groups[groupKey] = [];
                groupOrder.push(groupKey);
            }

            groups[groupKey].push(item);
        });

        return (
            <Box
                ref={downloadContent}
            >
                {groupOrder.map((groupName, groupIndex) => (
                    <Box key={`group-${groupIndex}`} sx={{ mb: 3 }}>
                        {/* Group Header */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2,
                                py: 1.5,
                                borderBottom: '2px solid #1976d2',
                                backgroundColor: '#f5f7fa',
                                borderRadius: '8px',
                                px: 2,
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '15px',
                                    color: '#1976d2',
                                    textTransform: 'capitalize'
                                }}
                            >
                                {groupName}
                            </Typography>
                            <Chip
                                label={groups[groupName].length}
                                size="small"
                                sx={{
                                    height: '22px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    borderRadius: '11px'
                                }}
                            />
                        </Box>

                        {/* Group Items */}
                        {groups[groupName].length > 0 ? (
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(3, 1fr)',
                                        md: 'repeat(4, 1fr)',
                                        lg: 'repeat(6, 1fr)',
                                        xl: 'repeat(8, 1fr)'
                                    },
                                    gap: 2
                                }}
                            >
                                {groups[groupName].map((agent: any, itemIndex: number) => (
                                    <AgentStatusCard
                                        action={agentDetails}
                                        key={`${groupIndex}-${itemIndex}`}
                                        agent={agent}
                                    />
                                ))}
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    py: 3,
                                    color: '#999',
                                    fontSize: '14px',
                                    fontStyle: 'italic'
                                }}
                            >
                                No agents in this group
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        );
    };

    return (
        <Card className={!moreData ? "changedCustomCard" : resized ? "changedCustomCard" : "customCard"} ref={tableContainerRef}>
            <div className="card-header">
                <div className="card-title">
                    Agent Monitor WFM  <div className="card-title-badge">Live</div>
                    {loadingRef.current && <CircularProgress size={16} sx={{ ml: 1 }} />}
                    <span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
                </div>
                <div className="card-actions">
                    <Grid container style={{ width: '125px', marginRight: '8rem' }}>
                        <Grid item sx={{ display: 'flex' }}>
                            <WidgetSearch onTextChange={handleOnSearch}></WidgetSearch>
                        </Grid>
                    </Grid>

                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Badge
                            variant='dot'
                            color="primary"
                            invisible={groupingColumns.length === 0}
                        >
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={handleGroupByOpen}
                                endIcon={<ArrowDropDownIcon />}
                                sx={{
                                    borderColor: '#cfd8dc',
                                    height: '32px',
                                    minWidth: 100,
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontWeight: 400,
                                    color: '#212121',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {groupingColumns.length > 0 ? groupingColumns[0].label : 'Group By'}
                            </Button>
                        </Badge>
                        <Menu
                            anchorEl={groupByAnchor}
                            open={Boolean(groupByAnchor)}
                            onClose={handleGroupByClose}
                            container={fullscreenContainer}
                        >
                            <MenuItem onClick={() => {
                                setGroupingColumns([]);
                                saveDataToDashboard('groupingColumns', []);
                                handleGroupByClose();
                            }}>
                                None {groupingColumns.length === 0 && '✓'}
                            </MenuItem>
                            <MenuItem onClick={() => {
                                handleGrouping({
                                    label: 'Skills',
                                    id: getColumnId({ id: 'SkillsFormatted', label: 'Skills' })
                                });
                                handleGroupByClose();
                            }}>
                                Skill {groupingColumns.length > 0 && groupingColumns[0].label === 'Skills' && '✓'}
                            </MenuItem>
                            <MenuItem onClick={() => {
                                handleGrouping({
                                    label: 'State',
                                    id: getColumnId({ id: 'AgentState', label: 'State' })
                                });
                                handleGroupByClose();
                            }}>
                                State {groupingColumns.length > 0 && groupingColumns[0].label === 'State' && '✓'}
                            </MenuItem>
                            {/* <MenuItem onClick={() => {
                                handleGrouping({
                                    label: 'Mode',
                                    id: getColumnId({ id: 'AgentMode', label: 'Mode' })
                                });
                                handleGroupByClose();
                            }}>
                                Mode {groupingColumns.length > 0 && groupingColumns[0].label === 'Mode' && '✓'}
                            </MenuItem> */}
                            {/* <MenuItem onClick={() => {
                                handleGrouping({
                                    label: 'Campaign Name',
                                    id: getColumnId({ id: 'CampaignNameOfLastCall', label: 'Campaign Name' })
                                });
                                handleGroupByClose();
                            }}>
                                Campaign {groupingColumns.length > 0 && groupingColumns[0].label === 'Campaign Name' && '✓'}
                            </MenuItem> */}
                        </Menu>
                    </Grid>

                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleSortByOpen}
                            endIcon={<ArrowDropDownIcon />}
                            sx={{
                                borderColor: '#cfd8dc',
                                height: '32px',
                                minWidth: 100,
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: 400,
                                color: '#212121',
                                justifyContent: 'space-between',
                            }}
                        >
                            Sort By
                        </Button>
                        <Menu
                            anchorEl={sortByAnchor}
                            open={Boolean(sortByAnchor)}
                            onClose={handleSortByClose}
                            container={fullscreenContainer}
                        >
                            <MenuItem onClick={() => handleSort('AgentName')}>
                                Agent Name {getSortIcon('AgentName')}
                            </MenuItem>
                            <MenuItem onClick={() => handleSort('AgentState')}>
                                State {getSortIcon('AgentState')}
                            </MenuItem>
                        </Menu>
                    </Grid>

                    <WidgetDownload fullscreenContainer={fullscreenContainer} element={downloadContent} name={'Agent Monitor WFM'} ></WidgetDownload>
                    <div className="card-icon" onClick={() => toggleDrawer(true)}>
                        <Badge badgeContent={agentListFilter.length + additionalFiltersLength} color="primary">
                            <FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
                        </Badge>
                    </div>
                </div>
            </div>
            <FilterDrawer
                isOpen={isDrawerOpen}
                toggleDrawer={toggleDrawer}
                applyFilters={handleApplyFilters}
                existingSelectedFilters={agentListFilter}
                setResponseLength={setresponseLength}
                allowedFilters={allowedFilters}
                existingFilterCategory={filterType}
                applyFilterOnExistingData={handleFilterExistingData}
                showAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? ['state', 'mode'] : []}
                initialAdditionalFilters={checkRoles("ROLE_DATA_ACCESS") ? additionalFilters : { state: [], mode: [] }}
                disableCampaignGroupSelection={true}
                fullscreenContainer={fullscreenContainer}
            />
            <Box sx={{ pt: 1, pl: 2 }}>
                {(agentListFilter.length > 0 || additionalFiltersLength > 0) && (
                    <div className="filter-outer">
                        <div className="filter-container">
                            <Stack direction="row" spacing={1}>
                                {agentListFilter.length > 0 && filterItems}
                                {additionalFiltersLength > 0 && additionalFiltersList()}
                            </Stack>
                        </div>
                        <div className="filter-remove" onClick={clearFilter}>
                            Remove
                        </div>
                    </div>
                )}
            </Box>

            <Paper sx={{
                width: '100%',
                height: '95%',
            }}>
                <Box sx={{ mx: 'auto', height: '100%', pl: 3, }}>
                    <Box
                        sx={{
                            height: '100%',
                            maxHeight: '95%',
                            overflowY: 'auto',
                            pb: 2
                        }}
                    >
                        {renderGroupedCards()}
                    </Box>
                </Box>
            </Paper>

            <Popover
                container={fullscreenContainer}
                open={isPopoverOpen}
                onClose={handleOnPopoverClose}
                anchorReference="anchorPosition"
                anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'center'
                }}
                slotProps={{
                    paper: {
                        sx: {
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                            borderRadius: '4px'
                        }
                    }
                }}
            >
                {getPopoverContent()}
            </Popover>
            {
                onselect &&
                <BargeInDrawerSip isOpen={isBargeInOpen} toggleDrawer={toggleBargeInDrawerSip} agentDetails={selectedAgent} callType={bargeinCallType} url={sipUrl} SipClient={bargeinCallType === 'SIP' ? sipClient : undefined} />
            }
            {
                screenBargeinData && <VideoPlayerIcon
                    row={{ liveRecordingData: screenBargeinData }}
                    isLive={true}
                    hideIcon={true}
                    defaultOpen={true}
                    onClose={() => { setScreenBargeinData(null) }}
                />
            }

            <ThresholdDrawer
                isOpen={isThresholdDrawerOpen}
                title={'Set'}
                toggleDrawer={toggleThresholdDrawer}
                thresholdItems={thresholdItems}
                savedThresholdList={savedThresholdList?.thresholdList || []}
                showSkillListByDefault={savedThresholdList.showSkillList}
            />
            <SelectPopover
                isOpen={isColumnsPopoverOpen}
                elementsArray={columns}
                anchorRef={columnsEleRefPoint}
                handlePopoverClose={handleOnColumnsPopoverClose}
                selectedElements={selectedColumns}
                handleOnSelectionChange={handleOnSelectColumnChange}
            />
            <Dialog open={openAlert} container={fullscreenContainer} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Release'}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{`Are you sure you want to release agent ${releaseDetails?.AgentName}`}?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className="buttons-container">
                        <Button variant="outlined" onClick={() => handleClose()}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={handleRelease} sx={{ ml: 2 }}>
                            Release
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
            <Dialog open={openLogOffAlert} container={fullscreenContainer} onClose={handleLogOffClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Logout'}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{`Are you sure you want to Logout agent ${logOffDetails?.AgentName}`}?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className="buttons-container">
                        <Button variant="outlined" onClick={() => handleLogOffClose()}>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={() => { handleLogOff(logOffDetails) }} sx={{ ml: 2 }}>
                            Logout
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </Card >
    );
}